module.exports = __webpack_public_path__ + "img/u893.f4cdfea5.svg";